import { ExternalLinks } from '@wellesley/router'
import { Button } from '@wellesley/ui'
import { SquareArrowOutUpRight, Users } from 'lucide-react'
import { FC } from 'react'

type CmpProps = {
  userUrl: string
}

const RemoteUserDisclaimer: FC<CmpProps> = ({ userUrl }) => {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="gap-xs flex items-center">
        <div className="flex size-10 items-center justify-center rounded-full border border-gray-200">
          <Users size={20} />
        </div>
        <div className="text-sm">
          <p className="mb-xxxs font-semibold text-gray-900">
            Some followers may not be visible
          </p>
          <span className="text-gray-400">
            You can see more on the original server
          </span>
        </div>
      </div>
      <ExternalLinks baseUrl={userUrl}>
        <a href={userUrl}>
          <Button variant="secondary" className="gap-xxs font-semibold">
            See more followers <SquareArrowOutUpRight />
          </Button>
        </a>
      </ExternalLinks>
    </div>
  )
}

export default RemoteUserDisclaimer
